import { render, staticRenderFns } from "./ProfileSteps.vue?vue&type=template&id=fb780a9a&scoped=true"
import script from "./ProfileSteps.vue?vue&type=script&lang=js"
export * from "./ProfileSteps.vue?vue&type=script&lang=js"
import style0 from "./ProfileSteps.vue?vue&type=style&index=0&id=fb780a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb780a9a",
  null
  
)

export default component.exports